export enum DoFilterSelectionMode {
  None = 'none',
  Single = 'single',
  All = 'all',
  Partial = 'partial',
}
